import { useEffect, useState } from 'react';
import { listInvites } from '../api';

/**
 * "Who did I invite, and did they join" — the other half of the share flow.
 *
 * Without this, inviting a colleague is a write-only action: you tap send and
 * never learn whether the email landed, whether it bounced, or whether they
 * actually signed up. That silence is also what makes people invite the same
 * person twice.
 *
 * Renders nothing until there is something to report.
 */

const LABEL = {
  sent: { text: 'Invited', color: '#475569' },
  signed_up: { text: 'Joined', color: '#047857' },
  undeliverable: { text: "Couldn't deliver", color: '#b45309' },
};

function when(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function InvitedColleagues() {
  const [invites, setInvites] = useState([]);

  useEffect(() => {
    // Never let a bookkeeping panel break the dashboard it sits on.
    listInvites()
      .then((r) => setInvites(r.invites || []))
      .catch(() => setInvites([]));
  }, []);

  if (!invites.length) return null;

  const joined = invites.filter((i) => i.status === 'signed_up').length;

  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>Colleagues you've invited</h2>
      <p className="muted" style={{ fontSize: 14, marginTop: -4 }}>
        {joined > 0
          ? `${joined} of ${invites.length} joined.`
          : `${invites.length} invited so far.`}
      </p>

      <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
        {invites.map((i) => {
          const label = LABEL[i.status] || LABEL.sent;
          return (
            <div
              key={i.id}
              style={{
                display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
                gap: 12, flexWrap: 'wrap', fontSize: 14,
                borderBottom: '1px solid #f1f5f9', paddingBottom: 8,
              }}
            >
              <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {/* A device share is anonymous by design — we never learn who a
                    text went to, so say that rather than inventing a name. */}
                {i.invitee_email || <span className="muted">Shared by link</span>}
              </span>
              <span style={{ color: label.color, whiteSpace: 'nowrap' }}>
                {label.text}
                <span className="muted" style={{ marginLeft: 8, fontSize: 12.5 }}>
                  {when(i.signed_up_at || i.created_at)}
                </span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
